import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PdfDownloadCard from './PdfDownloadCard';

export default function SyllabusSchedule({ packId }) {
  const navigate = useNavigate();
  const [resources, setResources] = useState(null);
  const [isPurchased, setIsPurchased] = useState(null);

  useEffect(() => {
    async function fetchData() {
      const purchaseResponse = await axios.get(`/api/packs/${packId}/is-purchased`);
      const isPurchasedData = purchaseResponse?.data?.data?.isPurchased;
      if (!isPurchasedData) return;
      setIsPurchased(isPurchasedData);
      if (!isPurchasedData) return;
      const res = await axios.get(`/api/packs/v2/dashboard/${packId}/basic`);
      const data = res?.data?.data;
      const tempResources = [];
      if (data?.schedulePdf) {
        tempResources.push({
          title: 'Test Series Schedule',
          url: data.schedulePdf,
        });
      }
      if (data?.syllabusPdf) {
        tempResources.push({
          title: 'Test Series Syllabus',
          url: data.syllabusPdf,
        });
      }
      setResources(tempResources);
    }

    fetchData();
  }, [packId]);

  useEffect(() => {
    if (isPurchased === false) {
      navigate('/v2/home');
    }
  }, [isPurchased]);

  return (
    <div className="grid grid-cols-2 gap-5">
      {resources &&
        resources?.map((item) => (
          <PdfDownloadCard title={item.title} link={item.url} resourceType={'Syllabus & Schedule'} />
        ))}
    </div>
  );
}
